import Axios from 'axios';
import qs from 'querystring';
import get from 'lodash.get';
import sentry from '../sentry';

const { captureException, captureResetPasswordError } = sentry();

export default (values, callback) => {
  const { _csrf, email, ticket, newPassword, confirmNewPassword } = values;
  if (_csrf === undefined || ticket === undefined || email === undefined) {
    // user will see
    // "Error occured. Please try again."
    // as front-end parser is not reading
    // error.message
    if (callback) callback(new Error('Unexpected error occured.'));
    return;
  }
  if (newPassword !== confirmNewPassword) {
    // may remove this
    // as validation is handled
    // on front-end by Yup
    if (callback) callback(new Error('Passwords does not match.'));
    return;
  }
  Axios({
    method: 'post',
    url: `https://${typeof window !== 'undefined' && window.location.hostname}/lo/reset`,
    data: qs.stringify(values),
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  })
    .then(() => {
      if (callback) callback();
    })
    .catch((error) => {
      const errorDesc = get(error, 'response.data.description');

      if (errorDesc) {
        captureException(new Error(errorDesc));
      } else {
        // no valid description from
        // error response
        // so we are sending more information
        // to Sentry
        const err = error;
        err.ticket = ticket;
        err.email = email;
        captureResetPasswordError(err);
      }

      // Axios enhances its error handling by
      // adding error response to the error caught
      // use error.response.data
      // to get the correct error message
      // or else customer will get generic error message
      // "Error occured. Please try again."
      // from front-end parser
      if (callback) callback(errorDesc ? get(error, 'response.data') : error);
    });
};
